
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';
import * as moment from 'moment';
import { AbstractControl } from '@angular/forms';
import * as saveAs from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
@Injectable({
    providedIn: 'root'
})
export class CommonAlgoService {

    constructor(private logger: LoggerService, private constants: ConstantsService, private http: HttpClient) { }

    alphanumericOnly(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        const inputValue = event.target.value;

        // Allow letters, numbers, and hyphen; disallow leading and trailing spaces
        if (
            (charCode >= 65 && charCode <= 90) ||    // A-Z
            (charCode >= 97 && charCode <= 122) ||   // a-z
            (charCode >= 48 && charCode <= 57) ||    // 0-9
            charCode === 45                          // Hyphen (-)
        ) {
            // Check for leading or trailing spaces
            // if (/^\s/.test(inputValue) || /\s$/.test(inputValue)) {
            //   return false;
            // }
            if (inputValue.indexOf(' ') > 0) {
                return false;
            }
            return true;
        }

        return false;
    }

    dobOnly(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;

        // Allow digits, hyphen, and slash
        if (
            (charCode >= 48 && charCode <= 57) ||   // 0-9
            charCode === 45                      // Hyphen (-)
            // || charCode === 47                          // Slash (/)
        ) {
            return true;
        }

        return false;
    }

    numberOnly(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 &&
            (charCode < 48 || charCode > 57) // 0-9
        ) {
            return false;
        }
        return true;
    }

    public firstLetterCapitalize(str: any) {
        var val: any;
        this.logger.log("firstLetterCapitalize: " + str);
        // if (str) {
        if (str == "" || str == 'undefined' || str == null) {
            val = str;
        } else {
            val = str.charAt(0).toUpperCase() + str.slice(1);
        }
        return val;
        // }
    }

    public firstLetterCapitalizeForEachWord(input: any) {
        var val: any = "";
        this.logger.log("firstLetterCapitalize: " + input);

        if (input == "" || input == 'undefined' || input == null) {
            val = input;
        } else if (typeof input === 'number') {
            val = input;
        } else {
            var strarray = input.split(" ");
            let element;
            for (let index = 0; index < strarray.length; index++) {
                let element = strarray[index];
                val += " " + element.charAt(0).toUpperCase() + element.slice(1);
                // element = element.slice(1, element.length);
                val = val.trim();
            }

            if (val.indexOf("-")) {
                var hyphanArray = val.split("-");
                var capitalizeHyphan: any = "";
                for (let j = 0; j < hyphanArray.length; j++) {
                    let element = hyphanArray[j];
                    capitalizeHyphan += "-" + element.charAt(0).toUpperCase() + element.slice(1);
                    // element = element.slice(1, element.length);
                    capitalizeHyphan = capitalizeHyphan.trim();
                }
                capitalizeHyphan = capitalizeHyphan.startsWith("-") ? capitalizeHyphan.replace("-", "") : capitalizeHyphan;
                return capitalizeHyphan;
            }
            this.logger.log("firstLetterCapitalizeForEachWord: " + val)
        }
        return "" + val;

    }
    alphabatesOnly(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (
            (charCode >= 65 && charCode <= 90) ||    // A-Z
            (charCode >= 97 && charCode <= 122) ||   // a-z
            (charCode >= 192 && charCode <= 255) || //À-ÖØ-öø-ÿ
            // (charCode >= 48 && charCode <= 57) ||    // 0-9
            charCode === 32 //space
            || charCode === 45 // - hypen
            || charCode === 46 //.
        )
            return true;
        else
            return false;
    }


    isValidPattern(value: string, pattern: string): boolean {
        const regex = new RegExp(pattern);
        return regex.test(value);
    }
    // alphabatesOnly(inputString) {
    //   this.logger.log(this.constants.pattern.test(inputString))
    //   return this.constants.pattern.test(inputString);
    // }

    dobFormate(input: any) {
        var dateObject1: any = "";
        if (input == "0000-00-00" || input == "" || input == undefined || input == null) {
            dateObject1 = "";
        } else {
            // Use moment to parse the input date with multiple formats
            var parsedDate = moment(input, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY", "YYYY/MM/DD", "DD/MM/YYYY", "MM/DD/YYYY", "yyyy-MM-dd'T'HH:mm:ss.SSSX", "EEE, MMM d, yyyy", "MMM d, yyyy", "MMMM d, yyyy", "d MMM yyyy", "yyyy-MM-dd HH:mm:ss"], true);

            // Check if the date is valid
            if (parsedDate.isValid()) {
                // If valid, store the moment object or convert it to a JavaScript Date object if needed
                dateObject1 = parsedDate.toDate();
                dateObject1 = dateObject1.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
            } else {
                // Handle invalid date formats as needed
                console.error("Invalid date format");
            }
        }
        this.logger.log("dateObject1.toString(): " + dateObject1.toString())
        return dateObject1.toString();
    }

    splitStringAddHypen(input: any) {
        if (input.trim() === '') {
            return '';
        }
        return input.split(' ').join('_');
    }


    transform(number: any) {
      if(number=="") {

        return "";

      }

      else {

        number = number.replace(/\D/g, '');

        // console.log(number)

        number = number.charAt(0) !== '+' ? "+"+number : ""+number;

      //   number = number.charAt(1) !== '1' ? "1"+number : ""+number;
      number = number.charAt(1) !== '1' ? number.charAt(0)+"1"+number.substring(1) : ""+number;


        const countryCodeStr = number.slice(0,2);

        const areaCodeStr = number.slice(2,5);

        const midSectionStr = number.slice(5,8);

        const lastSectionStr = number.slice(8);

        // console.log('aaaa');

        return `${countryCodeStr} (${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;

      }
        // if (number == "") {
        //     return "";
        // }
        // else {
        //     number = number.replace(/\D/g, '');
        //     this.logger.log(number)
        //     number = number.charAt(0) !== '+' ? "+" + number : "" + number;
        //     //   number = number.charAt(1) !== '1' ? "1"+number : ""+number;
        //     number = number.charAt(1) !== '1' ? number.charAt(0) + "1" + number.substring(1) : "" + number;
        //     const countryCodeStr = number.slice(0, 2);
        //     const areaCodeStr = number.slice(2, 5);
        //     const midSectionStr = number.slice(5, 8);
        //     const lastSectionStr = number.slice(8);
        //     this.logger.log('aaaa');
        //     return `${countryCodeStr} (${areaCodeStr})${midSectionStr}-${lastSectionStr}`;
        // }
    }

    replaceKey(array: any, oldKeyName: any, newKeyName: any) {
        return array.map((obj: any) => {
            // Create a new object with the updated key
            const newObj = { ...obj, [newKeyName]: obj[oldKeyName] };

            // Remove the old key if you want
            delete newObj[oldKeyName];

            return newObj;
        });
    }

    apt_suitecheck(
        control: AbstractControl
    ): { [key: string]: any } | null {
        var Regexp = /^[a-zA-Z0-9]{1,50}$/;
        if (control.value && !Regexp.test(control.value)) {
            return { aptexpression: true };
        }
        return null;
    }

    getQueryParams(url) {
        const queryParams = {};
        const urlSearchParams = new URLSearchParams(url.split('?')[1]);
        for (const [key, value] of urlSearchParams.entries()) {
            queryParams[key] = value;
        }

        return queryParams;
    }

    downloadPdf(url: any, fileName: any) {
        this.http.get(url, { responseType: "arraybuffer" }).subscribe(
            pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                // const fileName = `Invoice_${new Date().toISOString()}.pdf`
                // const fileName = `Invoice_${invoiceId}_${dueDates}.pdf`;
                saveAs(blob, fileName);
            },
            err => {
                this.logger.log("err->", err);
            }
        );
    }
}



